import Vue from 'vue';

import App from './app.vue';
import Vue2Filters from 'vue2-filters';
import router from './router';
import * as config from './shared/config/config';
import InfiniteLoading from 'vue-infinite-loading';
import AccountService from './account/account.service';

import '../content/scss/global.scss';
import '../content/scss/vendor.scss';

import '../content/material-icon/css/materialdesignicons.min.css';
import LandingContactService from "@/pages/landing-contact/landing-contact.service";
import ContactUsService from "@/pages/contact-us/contact-us.service";
import InvestmentContactService from "@/pages/investment-contact/investment-contact.service";
import CareerService from "@/pages/career/career.service";
import ProductContactService from "@/pages/product-contact/product-contact.service";
import SoftwareContactService from "@/pages/software-contact/software-contact.service";
import ServiceContactService from "@/pages/service-contact/service-contact.service";
import ArticlesService from "@/pages/articles/article.service";
import NewsService from "@/pages/news/news.service";
import ProductsService from "@/pages/products/products.service";
import DocumentService from "@/shared/services/document.service";
import JobApplicationsService from "@/pages/job-applications/job-applications.service";
import UserManagementService from "@/account/user-management/user-management.service";
import RegistrationMailsService from "@/pages/registration-mails/registration-mails.service";
import DashboardService from "@/pages/dashboard/dashboard.service";

Vue.config.productionTip = false;
config.initVueApp(Vue);
Vue.use(Vue2Filters);

Vue.component('infinite-loading', InfiniteLoading);

const store = config.initVueXStore(Vue);
const vuetify = config.initVuetify(Vue);

const accountService = new AccountService(store, router);

router.beforeEach(async (to, from, next) => {
  if (!to.matched.length) {
    next('/not-found');
  } else if (to.meta && to.meta.authorities && to.meta.authorities.length > 0) {
    accountService.hasAnyAuthorityAndCheckAuth(to.meta.authorities).then(value => {
      if (!value) {
        sessionStorage.setItem('requested-url', to.fullPath);
        next('/');
      } else {
        next();
      }
    });
  } else {
    next();
  }
});

new Vue({
  el: '#app',
  components: { App },
  template: '<App/>',
  router,
  provide: {
    accountService: () => accountService,
    landingContactService: () => new LandingContactService(),
    contactUsService: () => new ContactUsService(),
    investmentContactService: () => new InvestmentContactService(),
    careerService: () => new CareerService(),
    productContactService: () => new ProductContactService(),
    softwareContactService: () => new SoftwareContactService(),
    serviceContactService: () => new ServiceContactService(),
    articleService: () => new ArticlesService(),
    newsService: () => new NewsService(),
    productsService: () => new ProductsService(),
    documentService: () => new DocumentService(),
    jobApplicationsService: () => new JobApplicationsService(),
    userManagementService: () => new UserManagementService(),
    registrationMailsService: () => new RegistrationMailsService(),
    dashboardService: () => new DashboardService(),
  },
  store,
  vuetify,
});
